import React from "react";

import { Route, Switch, Redirect } from "react-router-dom";

import AuthFailedPage from "./Pages/AuthFailedPage/AuthFailedPage";
import UnderMaintenance from "./Pages/UnderMaintenance/UnderMaintenance";
import UserConfiguration from "./Pages/UserConfiguration/UserConfiguration";

const LoggedIn = () => (
  <Switch>
    <Route exact path="/user-configuration" component={UserConfiguration} />
    <Route path="/auth-failed" component={(props) => <AuthFailedPage history={props.history} />} />
    <Route path="/maintenance" component={(props) => <UnderMaintenance history={props.history} />} />
    <Redirect to="/user-configuration" />
  </Switch>
);

export default LoggedIn;
